import { render, staticRenderFns } from "./WelfareAttendanceDetails.vue?vue&type=template&id=29958b53&scoped=true"
import script from "./WelfareAttendanceDetails.vue?vue&type=script&lang=js"
export * from "./WelfareAttendanceDetails.vue?vue&type=script&lang=js"
import style0 from "./WelfareAttendanceDetails.vue?vue&type=style&index=0&id=29958b53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29958b53",
  null
  
)

export default component.exports